import { put, deleteReq } from './api';

export const setArchived = ({ body, bookletId }) =>
  put(`/booklets/${bookletId}/archive/`, JSON.stringify(body), {
    'Content-Type': 'application/json',
  });
export const deleteBooklet = ({ bookletId }) =>
  deleteReq(`/booklets/${bookletId}`, {
    'Content-Type': 'application/json',
  });



// WEBPACK FOOTER //
// ./src/services/archiveApi.js